const API_BASE_URL = '/api';

export interface RecentResourceView {
  postId: number;
  viewedAt: string;
}

async function authHeaders(getToken: () => Promise<string | null>): Promise<HeadersInit | null> {
  const token = await getToken();
  if (!token) return null;
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export async function fetchRecentResources(
  getToken: () => Promise<string | null>,
  options?: { limit?: number }
): Promise<RecentResourceView[]> {
  const headers = await authHeaders(getToken);
  if (!headers) return [];
  const params = new URLSearchParams();
  if (options?.limit != null && Number.isFinite(options.limit) && options.limit > 0) {
    params.set('limit', String(Math.floor(options.limit)));
  }
  const query = params.toString();
  const response = await fetch(
    `${API_BASE_URL}/me/recent-resources${query ? `?${query}` : ''}`,
    { headers }
  );
  if (!response.ok) throw new Error('Failed to load recent resources');
  const body = (await response.json()) as { views?: RecentResourceView[] };
  return body.views ?? [];
}

export async function recordResourceView(
  getToken: () => Promise<string | null>,
  postId: number
): Promise<void> {
  const headers = await authHeaders(getToken);
  if (!headers) return;
  await fetch(`${API_BASE_URL}/me/recent-resources`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ postId }),
  });
}
